import * as Commands from './api/Commands';
import * as Options from './api/Options';
import * as Autocomplete from './ui/Autocomplete';
import * as Buttons from './ui/Buttons';
import * as AttributeFilter from './core/AttributeFilter';
import {PLUGIN_NAME} from './constants';

function Plugin(): void | null {
  const tinymce = (window as any).tinymce;

  if (!tinymce) {
    return null;
  }

  const PluginManager = tinymce.util.Tools.resolve('tinymce.PluginManager');

  if (PluginManager.lookup[PLUGIN_NAME]) {
    // if plugin exists, don't add it again
    return null;
  }

  PluginManager.add(PLUGIN_NAME, (editor: any) => {
    Options.register(editor);
    Commands.register(editor);
    Buttons.register(editor);
    Autocomplete.register(editor);
    AttributeFilter.setup(editor);
  });
}

export default Plugin;
